import React from 'react';
import { DesignerAttribution, DesignerAttributionProps } from '@vp/ep-designer-attribution';
import {
    Box,
    Column,
    FluidImage,
    FluidImageProps,
    GridContainer,
    H3,
    P,
    Row,
    tokens,
} from '@vp/swan';
import styled from 'styled-components';

type InspirationImage = {
    src: string;
    alt: string;
    designerAttribution: DesignerAttributionProps;
};

type InspirationProps = {
    title: string;
    subTitle?: string;
    images: InspirationImage[];
};

const Image = styled(FluidImage)<FluidImageProps>`
    border-radius: ${tokens.SwanBaseBorderRadius400};
`;

export const Inspiration = (props: InspirationProps) => (
    <GridContainer>
        <Row>
            <Column span={12}>
                <H3>{props.title}</H3>
                {props.subTitle && <P margin={0}>{props.subTitle}</P>}
                <Box mb="between-subsections" />
                <Row>
                    {props.images.map((image, index) => (
                        <Column key={index} span={2} spanSm={4} spanXs={6} mb={5}>
                            <Image src={image.src} alt={image.alt} />
                            <DesignerAttribution
                                designerName={image.designerAttribution.designerName}
                                avatarURL={image.designerAttribution.avatarURL}
                            />
                        </Column>
                    ))}
                </Row>
            </Column>
        </Row>
    </GridContainer>
);
